<template>
  <div class="grid-wrapper">
    <div class="uk-flex uk-flex-between">
      <h5
        class="title"
        style="cursor: pointer; display: contents;"
      >
        Cadena de fríod - {{ product.elementProduct.product }}
      </h5>
      <div
        style="cursor: pointer;"
        @click="downloadFile"
      >
        <p style="display: contents;">
          Descargar Excel
        </p>
        <img
          style="height: 20px; margin: 10px"
          src="../../assets/img/exportExcel.png"
          height="50"
        >
      </div>
    </div>
    <ag-grid-vue
      id="myGrid"
      style="width: 100%; height: 500px;"
      class="ag-theme-alpine"
      :grid-options="gridOptions"
      :default-col-def="defaultColDef"
      :column-defs="columnDefs"
      :row-data="rowData"
      @grid-ready="onGridReady"
    />
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue3'
import { mapState } from 'vuex'
export default {
  components: {
    'ag-grid-vue': AgGridVue
  },
  data: () => ({
    gridOptions: null,
    gridApi: null,
    columnApi: null,
    columnDefs: null,
    defaultColDef: null,
    rowData: [],
    totalRows: 10
  }),
  computed: {
    ...mapState({
      coldChain: state => state.coldChain,
      product: state => state.product
    })
  },
  beforeMount () {
    this.gridOptions = {}
    const coldChain = [{ name: 'date', text: 'Fecha' }, ...this.coldChain]
    this.columnDefs = coldChain.map((x) => {
      return {
        field: x.name,
        headerName: x.text
      }
    })
    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
      minWidth: 100,
      flex: 1
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    this.gridColumnApi = this.gridOptions.columnApi
  },
  methods: {
    async downloadFile () {
      const coldChain = [{ name: 'date', text: 'Fecha' }, ...this.coldChain]
      const columns = coldChain.map((x) => x.text)

      const rows = []
      for (let i = 1; i <= this.totalRows; i++) {
        const result = new Date()
        result.setDate(result.getDate() + i)
        const data = [result.toDateString()]
        columns.forEach((col) => {
          if (col !== 'Fecha') data.push('')
        })
        rows.push(data)
      }
      const title = `Cadena de frío - ${this.product.elementProduct.product}`
      await this.$excelPlugin.downloadFile(columns, rows, title, `${title}.xlsx`, null)
    },
    onGridReady (params) {
      this.rowData = []
      const obj = {}
      this.columnDefs.filter(x => x.field !== 'date').forEach((column) => {
        obj[column.field] = null
      })
      for (let i = 1; i <= this.totalRows; i++) {
        const result = new Date()
        result.setDate(result.getDate() + i)
        this.rowData.push({ date: result.toDateString() })
      }
    }
  }
}
</script>
